module.exports = __webpack_public_path__ + "img/code-event.3ce56b58.svg";